<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1 class="text">{{this.$route.meta.title}}</h1>
            </div>

            <div class="section-body">
                <div class="row">
                    <div class="col-12 text-center mt-3" v-if="no_data === null">
                        <div class="half-circle-spinner">
                            <div class="circle circle-1"></div>
                            <div class="circle circle-2"></div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === false">
                        <div class="card bdr-15" >
                            <div class="card-header border-0 pb-4 tb-card">
                                <div class="table-sorting">
                                    <div class="table-search float-left">
                                        <vue-search 
                                            :search="sorting"
                                            @searchdata="getDistributors()">
                                        </vue-search>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive bdr-15">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Name</th>
                                                <th>Email/Username</th>
                                                <th>Total Slot</th>
                                                <th>Total Agent</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="tr-ac" v-for="data in distributors.data" :key="data.id" v-on:click="agentDistributors(data)">
                                                <td v-on:click.stop="">
                                                    <button type="submit" @click.prevent="addSlots(data)" class="btn btn-new mp"><i class="uil uil-plus mr-2"></i> Add Slot</button>
                                                </td>
                                                <td>{{data.name}}</td>
                                                <td>{{data.email}}</td>
                                                <th><label class="badge badge-success">{{data.slots}} Slots</label></th>
                                                <td><label class="badge badge-primary">{{data.agents.length}} Agents</label></td>
                                            </tr>
                                        
                                        </tbody>
                                        
                                    </table>
                                    <p v-if="distributors.total === 0" class="text-center no-data">Distributors data not found</p>
                                </div>
                            </div>
                            <div class="card-footer">
                                <vue-pagination :pagination="distributors"
                                                :sorting="sorting"
                                                @paginate="getDistributors()">
                                </vue-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === true && sorting.search === ''">
                        <div class="card bdr-15">
                            <div class="card-body card-nitem text-center">
                                <img class="mb-5" src="@/assets/img/no-data.svg" alt="">
                                <div class="nitem-desc">
                                    <h2>Distributors Data Still Empty</h2>
                                    <p>You can add distributor data first after you manage distributor slot</p>
                                    <div class="tabel-action">
                                        <router-link class="btn btn-new" :to="{ name: 'distributor' }">
                                            <i class="uil uil-plus mr-2"></i>
                                            Add Distibutor
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <modal-form @getDistributors="getDistributors()"></modal-form>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import VuePagination from "@/components/Pagination.vue";
    import VueSearch from "@/components/Search.vue";
    import ModalForm from '../slot-distributor/ModalForm.vue'
    import moment from 'moment'

    export default {
        name: "distributors",
        components: {
            VuePagination,
            VueSearch,
            ModalForm
        },
        data(){
            return {
                del_distributors:[],
                no_data: null,
            }
        },
        mounted(){
            this.title = this.$route.meta.title;
            this.getDistributors().then(() => {
                if(this.distributors.total == 0){
                    this.no_data = true
                }else{
                    this.no_data = false
                }
            })
        },
        filters: {
            formatDate: function(val){
                if(val){
                    return moment(String(val)).format('DD MMMM YYYY')
                }else{
                    return '-'
                }
            },
        },
        computed:{
            ...mapState('DistributorsControl', {
                distributors: state => state.distributors,
                sorting: state => state.sorting
            }),
        },
        methods: {
            ...mapActions('DistributorsControl', ['getDistributors','deleteDistributors']),
            ...mapMutations('DistributorsControl', ['CLEAR_DISTRIBUTORS','ASSIGN_FORM','ASSIGN_DATA_AGENTS_DISTRIBUTOR']),
            
            agentDistributors:function(data){
                this.ASSIGN_DATA_AGENTS_DISTRIBUTOR(data)
                this.$bvModal.show('modal-Agent-Distributors')
            },
            addSlots:function(data){
                this.ASSIGN_DATA_AGENTS_DISTRIBUTOR(data)
                this.$bvModal.show('modal-Add-Slots')
            },
        },
        destroyed(){
            this.CLEAR_DISTRIBUTORS()
        }
    };

</script>
